var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oncourse"},[_c('div',{staticClass:"oncourse--content"},[_c('h1',[_vm._v("OnCourse")])])])
}]

export { render, staticRenderFns }